import { useCallback } from 'react'

import { useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { isEmpty } from 'lodash'

const useDeleteCheckIns = (): [(ids: number[]) => Promise<void>, boolean] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<void>()

  const deleteCheckIns = useCallback(
    async (ids: number[]) => {
      if (isEmpty(ids)) return

      return request({
        method: 'del',
        url: `/organizations/${organization.id}/check-ins`,
        config: {
          queryStringParameters: {
            ids: ids.join(','),
          },
        },
      })
    },
    [organization.id, request],
  )

  return [deleteCheckIns, status.loading]
}

export default useDeleteCheckIns
